import { render, staticRenderFns } from "./DeleteFolderAction.vue?vue&type=template&id=68a97554&scoped=true"
import script from "./DeleteFolderAction.vue?vue&type=script&lang=js"
export * from "./DeleteFolderAction.vue?vue&type=script&lang=js"
import style0 from "./DeleteFolderAction.vue?vue&type=style&index=0&id=68a97554&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a97554",
  null
  
)

export default component.exports